<template>
  <div>
    <div v-if="componentsData && componentsData.length">
      <div v-for="(item, index) in componentsData" :key="index">
        <div v-if="item.componentType === 'general'">
          <component :is="item.componentName" :bot-response="item" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TvmKbbTradeValue from "../TvmSellUsYourCar/TvmKbbTradeValue.vue";
import TvmBbTradeValue from "../TvmSellUsYourCar/TvmBbTradeValue.vue";
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ["componentsData"],
  comments: {
    'tvm_kbb_trade_value': TvmKbbTradeValue,
    'tvm_bb_trade_value': TvmBbTradeValue
  }
};
</script>
